import React, { Component } from 'react';
import _ from 'lodash';
import ProductCard from '../components/product/ProductCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class ProductGrid extends Component {

    constructor(props) {
        super(props);

        this.renderProducts = this.renderProducts.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !_.isEqual(this.props, nextProps);
    }

    renderProducts(products) {
        if (products.length <= 0) {
            return (
                <div className="no-product-found">
                    <div className="no-product-found-img" style={{ paddingBottom: "30px", color: "#cecece", fontSize: "100px" }}>
                        <FontAwesomeIcon icon={["fal", "shopping-bag"]} style={{ display: "block", margin: "auto" }} />
                    </div>
                    ไม่พบรายการสินค้าที่คุณค้นหา โปรดลองใหม่อีกครั้ง
                </div>
            );
        }
        return _.map(products, (product, index) => {
            return <div key={product.item_id + "_" + index} className="col-6 col-md-4 col-lg-3"><ProductCard item={product} refresh={this.props.refresh} showOnlyOneButton={true} /></div>
        });

    }

    render() {
        const { products } = this.props;
        if (products) {
            return (
                <div className="row" style={{ minHeight: "200px" }}>
                    {this.renderProducts(products)}
                </div>
            )
        } else {
            return null;
        }
    }
}

export default ProductGrid